<template>
  <div>
    <v-container>
        <v-layout>
            <v-flex xs12>
              <div :id="adId">
              </div>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import postscribe from "postscribe";
var ready = require('document-ready')
//square ad
// <script async id="mNCC" type="text/javascript" language="javascript">var medianet_width = "180"; var medianet_height = "150"; var medianet_crid = "462272657"; var medianet_versionId = "3111299";<\/script>
// long ad
// <script async id="mNCC" type="text/javascript" language="javascript">var medianet_width = "468"; var medianet_height = "60"; var medianet_crid = "773677337"; var medianet_versionId = "3111299";<\/script>
export default {
  name: "Propeller",
  props:["adChoice"],
  data() {
    return {
      adId: Date.now(),
      adsArray:[`<script src="//go.mobtrks.com/notice.php?p=1846157&interstitial=1"><\/script>`,
      `<script type="text/javascript" src="//go.oclaserver.com/apu.php?zoneid=1850389"><\/script>`]
    };
  },

  mounted() {
    var vm = this;
    ready(function () {
      let addEl = new Promise((resolve, reject) => {
          postscribe(
            `#${vm.adId}`,
            `${vm.adsArray[vm.adChoice]}`,
            {
              done: function(x) {}
            }
          );

        resolve();
      });      
      addEl.then(function(result) {
        //console.log(result) do nothing
      });
    })

    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.container {
  max-width: 1250px;
}
</style>



// WEBPACK FOOTER //
// src/components/ads/Propeller.vue